import { useEffect } from 'react';



// Custom hook
export const useGtmTrack = () => {
  // Definirajte gtmTrack funkciju
  const gtmTrack = (event: string, category?: string, action?: string, label?: string) => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event,
        trackingData: {
          category: category || 'Zdravstveno osiguranje',
          action: action || 'priceCheck',
          label: label || 'Dopunsko osiguranje'
        }
      });
      console.log("GTM sent")
    } catch (e) {
      console.log(e)
    }
  };

  useEffect(() => {
    if (!window.gtmTrack) {
      window.gtmTrack = gtmTrack;
    }
  }, [gtmTrack]);

  return window.gtmTrack;
};